import {Component, ViewChild} from '@angular/core';

@Component({
    selector: 'acabim-admin-main-site-settings',
    templateUrl: './site.component.html',
    styleUrls: ['./site.component.scss']
})
export class SiteComponent {
    @ViewChild('siteList') public siteList: any;
    @ViewChild('archivedSiteList') public archivedSiteList: any;

    index = 0;

    selectTab($event: { index: number; }) {
        if ($event.index === 0) {
            this.siteList.dataTable.requestImmediateDataRefresh();
        } else {
            this.archivedSiteList.dataTable.requestImmediateDataRefresh();
        }
        this.index = $event.index;
    }

}
